import { createContext } from 'react';

import { WizardState } from '../types/wizard-state';

export const WizardStateContext = createContext<WizardState | null>(null);
